/**
 * See /.env
 */
export interface IConfig {
  REACT_APP_APIV4_BASE_URL: string;
  REACT_APP_FE_BASE_URL: string;
  REACT_APP_IDENTITY_API_HOST: string;
  HIPAY_ACCOUNT: string;
  HIPAY_TOKEN: string;
  HIPAY_STAGE: boolean
}

export const config: IConfig = {
  REACT_APP_APIV4_BASE_URL: process.env.REACT_APP_APIV4_BASE_URL || "",
  REACT_APP_FE_BASE_URL: process.env.REACT_APP_FE_BASE_URL || "",
  REACT_APP_IDENTITY_API_HOST: process.env.REACT_APP_IDENTITY_API_HOST || "",
  HIPAY_ACCOUNT: process.env.REACT_APP_HIPAY_ACCOUNT || "",
  HIPAY_TOKEN: process.env.REACT_APP_HIPAY_TOKEN || "",
  HIPAY_STAGE: !(["false", "no"].includes((process.env.REACT_APP_HIPAY_STAGE ?? "true").toLowerCase())),
};
